import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { cuentasBancariasAPI } from '../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../context/AuthContext';
import '../Clientes.css';

const CuentasBancarias = () => {
  const [cuentas, setCuentas] = useState([]);
  const [loading, setLoading] = useState(true);
  const { hasPermission } = useAuth();

  useEffect(() => {
    loadCuentas();
  }, []);

  const loadCuentas = async () => {
    try {
      setLoading(true);
      const response = await cuentasBancariasAPI.getAll({ includeInactive: true });
      if (response.success) {
        setCuentas(response.data);
      }
    } catch (error) {
      toast.error('Error al cargar cuentas bancarias');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Está seguro de eliminar esta cuenta bancaria?')) return;

    try {
      const response = await cuentasBancariasAPI.delete(id);
      if (response.success) {
        toast.success('Cuenta bancaria eliminada exitosamente');
        loadCuentas();
      }
    } catch (error) {
      toast.error(error.message || 'Error al eliminar cuenta bancaria');
    }
  };

  if (loading) {
    return <div className="loading">Cargando...</div>;
  }

  return (
    <div className="clientes pagina-listado pagina-listado--scroll">
      <div className="page-header">
        <h1>Cuentas Bancarias</h1>
        {hasPermission('gestionar_cuentas_bancarias') && (
          <Link to="/cuentas-bancarias/nuevo" className="btn-primary">Nueva Cuenta</Link>
        )}
      </div>

      <div className="listado-panel clientes-listado listado-controles">
        <div className="listado-panel-cuerpo clientes-listado-cuerpo">
          <div className="listado-tabla-area clientes-listado-tabla-area">
            <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>Número de Cuenta</th>
              <th>Tipo</th>
              <th>Banco</th>
              <th>Moneda</th>
              <th>CBU / CVU</th>
              <th>Alias</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {cuentas.length === 0 ? (
              <tr>
                <td colSpan="8" className="no-data">No hay cuentas bancarias registradas</td>
              </tr>
            ) : (
              cuentas.map(cuenta => (
                <tr key={cuenta.id}>
                  <td><strong>{cuenta.numero_cuenta}</strong></td>
                  <td>{cuenta.tipo === 'CtaCte' ? 'Cuenta Corriente' : 'Caja de Ahorros'}</td>
                  <td>{cuenta.banco_nombre} {cuenta.banco_codigo && `(${cuenta.banco_codigo})`}</td>
                  <td>{cuenta.moneda || 'ARS'}</td>
                  <td>{cuenta.cbu_cvu || '—'}</td>
                  <td>{cuenta.alias || '—'}</td>
                  <td>
                    <span className={`badge ${cuenta.activo ? 'activo' : 'inactivo'}`}>
                      {cuenta.activo ? 'Activo' : 'Inactivo'}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      {hasPermission('gestionar_cuentas_bancarias') && (
                        <>
                          <Link to={`/cuentas-bancarias/editar/${cuenta.id}`} className="btn-edit">Editar</Link>
                          <button onClick={() => handleDelete(cuenta.id)} className="btn-delete">Eliminar</button>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CuentasBancarias;

